import React, { Component } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { withRouter } from "react-router-dom";
import moment from "moment";

//Strings
import { Strings } from "../Translations/i18n";

//Styles
import "../LoanDetails/LoanDetails.scss";
import "./AuditTrail.scss";

//Custom UI components

import SearchFilter from "../CustomUIComponents/SearchFilter/SearchFilter";
import Pagination from "../CustomUIComponents/Pagination/Pagination";

//Constants
import { PERFOMER_ROLE, PERFOMER_TYPE } from "./Constants";
import {
  CONFIGURATION_DATE_TIME_FORMAT,
  DATE_FORMAT,
} from "../Utils/Constants";
import {
  DEFAULT_PAGINATION_ACTIVE_PAGE,
  DEFAULT_PAGINATION_AUDIT_RECORDS_COUNT,
} from "../CustomUIComponents/Pagination/PaginationConstants";

import Utility from "../Utils/Utility";
import { APPLICATION_CONFIGURATIONS } from "../Utils/ApplicationConfigurations";

moment.locale(APPLICATION_CONFIGURATIONS.applicationLanguage);

class AuditTrail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandRowIndex: [],
      auditTrailFirstRowColumns: [
        "action",
        "sectionType",
        "performerRole",
        "performer",
        "performedAt",
      ],
      auditTrailSecondRowColumns: ["key", "oldData", "newData"],
      recordsPerPage: DEFAULT_PAGINATION_AUDIT_RECORDS_COUNT,
      activePage: DEFAULT_PAGINATION_ACTIVE_PAGE,
      auditType: "",
    };
  }

  componentDidMount() {
    this.handleOnClickSearchFilter(false);
  }

  onFirstRowClick = (index, row) => {
    if (this.props.isExpandable) {
      let expandRowIndex =
        this.state.expandRowIndex.length !== 0
          ? [...this.state.expandRowIndex]
          : [];

      if (row.newData === null && row.oldData === null) {
        return;
      } else {
        if (expandRowIndex && expandRowIndex.includes(index)) {
          expandRowIndex.splice(expandRowIndex.indexOf(index), 1);
        } else {
          expandRowIndex.push(index);
        }
        this.setState({ expandRowIndex });
      }
    }
  };

  renderExpandableRowValues = (row, secondRow, column) => {
    let value = secondRow[column];
    if (
      row.action === "DATA_MODIFIED" &&
      (column === "oldData" || column === "newData") &&
      (secondRow.key === "dateOfBirth" ||
        secondRow.key === "documentExpirationDate")
    ) {
      value =
        secondRow[column] !== "N/A"
          ? moment(secondRow[column]).format(DATE_FORMAT)
          : Strings("NA");
    } else if (
      secondRow.key === "amountCollected" ||
      secondRow.key === "amount" ||
      secondRow.key === "lateFeeAmount" ||
      secondRow.key === "emiApproved" ||
      secondRow.key === "amtReq" ||
      secondRow.key === "emi" ||
      secondRow.key === "phn" ||
      secondRow.key === "food" ||
      secondRow.key === "other" ||
      secondRow.key === "total" ||
      secondRow.key === "housing" ||
      secondRow.key === "amenities" ||
      secondRow.key === "loanCredit" ||
      secondRow.key === "remittance" ||
      secondRow.key === "carTransport" ||
      secondRow.key === "salary" ||
      secondRow.key === "partnerSalary" ||
      secondRow.key === "amountApproved"
    ) {
      value = value
        ? Utility.getCurrencyRepresentationOfAmount(value)
        : Strings("NA");
    } else if (
      row.action === "ACCESS_MODIFIED" &&
      (column === "oldData" || column === "newData")
    ) {
      let features = secondRow[column].map((feature) => Strings(feature));
      value = features.toString();
    } else if (row.action === "DEACTIVATED") {
      if (column === "oldData") {
        value = "ACTIVE";
      } else if (column === "newData") {
        value = "DEACTIVATE";
      }
    } else if (
      row.action === "ADDED_NEW_PROFILE_PIC" &&
      (column === "oldData" || column === "newData")
    ) {
      value = "NA";
    }
    return value ? Strings(value) : Strings("NA");
  };

  renderFirstRowValues = (row, column) => {
    let value = row[column];

    if (column === "performedAt") {
      value = moment(row[column]).format(CONFIGURATION_DATE_TIME_FORMAT);
    }
    return value ? Strings(value) : Strings("NA");
  };

  handleOnClickSearchFilter = (isDefaultOffset) => {
    isDefaultOffset &&
      this.setState({
        activePage: DEFAULT_PAGINATION_ACTIVE_PAGE,
      });

    let requestData = {
      performer: this.state.performer ? this.state.performer : null,
      performerRole: this.state.performerRole ? this.state.performerRole : null,
      performerType: this.state.performerType ? this.state.performerType : null,
      action: this.state.action ? this.state.action : null,
      limit: this.state.recordsPerPage,
      offset: isDefaultOffset
        ? DEFAULT_PAGINATION_ACTIVE_PAGE - 1
        : this.state.activePage - 1,
    };
    this.props.getAuditTrail(requestData);
  };

  handleOnClickResetSearch = () => {
    this.setState(
      {
        action: "",
        performerRole: "",
        performer: "",
        activePage: DEFAULT_PAGINATION_ACTIVE_PAGE,
        performerType: "",
      },
      () => {
        this.handleOnClickSearchFilter(false);
      }
    );
  };

  onPageChange = ({ page, pageLength }) => {
    this.setState(
      {
        activePage: page,
        recordsPerPage: pageLength,
      },
      () => {
        this.handleOnClickSearchFilter(false);
      }
    );
  };

  handleOnChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  renderSearchFilter = () => {
    let filters = [
      {
        id: "action",
        type: "select",
        placeholder: "action",
        name: "action",
        onChange: this.handleOnChange,
        value: this.state.action,
        dropdownList: this.props.getAuditTrailActionFilter(
          this.props.auditTrailReducer.auditType
        ),
      },
      {
        id: "performerRole",
        type: "select",
        placeholder: "performerRole",
        placeholderTopClass: "placeholderTopClass",
        onChange: this.handleOnChange,
        value: this.state.performerRole,
        dropdownList: PERFOMER_ROLE,
        name: "performerRole",
      },
      {
        id: "performerType",
        type: "select",
        placeholder: "performerType",
        placeholderTopClass: "placeholderTopClass",
        onChange: this.handleOnChange,
        value: this.state.performerType,
        dropdownList: PERFOMER_TYPE,
        name: "performerType",
      },
      {
        id: "performer",
        type: "text",
        placeholder: Strings("performer"),
        placeholderTopClass: "placeholderTopClass",
        onChange: this.handleOnChange,
        value: this.state.performer,
        name: "performer",
        disabled: this.state.performerType === "SYSTEM",
      },
    ];

    return (
      <SearchFilter
        filters={filters}
        handleOnClickFilterSearch={this.handleOnClickSearchFilter}
        handleOnClickResetSearchValues={this.handleOnClickResetSearch}
      />
    );
  };

  renderNestedColumns = (secondRow, column, nestedColumn) => {
    let value;
    if (
      secondRow.key === "visitTime" &&
      secondRow[column][nestedColumn] !== null
    ) {
      value = `${Strings(nestedColumn)} : ${
        secondRow[column][nestedColumn]["hour"]
      } ${Strings("hr")}, ${secondRow[column][nestedColumn]["minute"]}${Strings(
        "min"
      )}`;
    } else if (
      nestedColumn === "income" ||
      nestedColumn === "salary" ||
      nestedColumn === "amount"
    ) {
      value = secondRow[column][nestedColumn]
        ? `${Strings(
            nestedColumn
          )} : ${Utility.getCurrencyRepresentationOfAmount(
            secondRow[column][nestedColumn]
          )}`
        : `${Strings(nestedColumn)} : ${Strings("NA")}`;
    } else {
      value = secondRow[column][nestedColumn]
        ? `${Strings(nestedColumn)} : ${Strings(
            secondRow[column][nestedColumn]
          )}`
        : `${Strings(nestedColumn)} : ${Strings("NA")}`;
    }
    return value;
  };

  render() {
    return (
      <Row className="paddingTop">
        <Row className="mainHeaderApplication">{`${Strings("auditTrail")} - ${
          this.props.header
        }`}</Row>
        <Row className="marginBottom">{this.renderSearchFilter()}</Row>

        {this.props.auditTrailData.length !== 0 ? (
          <>
            <Row className={"amortizationHeader"}>
              {this.state.auditTrailFirstRowColumns.map((column) => {
                return (
                  <Col md={2} className="text-left">
                    {Strings(column)}
                  </Col>
                );
              })}
            </Row>
            {this.props.auditTrailData.map((row, index) => {
              let notExpandableRow =
                row.oldData === null && row.newData === null;
              return (
                <>
                  <Row
                    className={
                      this.state.expandRowIndex.length !== 0 &&
                      this.state.expandRowIndex.includes(index)
                        ? "expandedFirstRow cursorPointer"
                        : "firstRow cursorPointer"
                    }
                    onClick={() => {
                      row.action !== "DRAFTED" &&
                        row.action !== "ACTIVATED" &&
                        row.action !== "DEACTIVATED" &&
                        this.onFirstRowClick(index, row);
                    }}
                  >
                    {this.state.auditTrailFirstRowColumns.map((column) => {
                      return (
                        <Col md={2} className="text-left">
                          {this.renderFirstRowValues(row, column)}
                        </Col>
                      );
                    })}
                    {!notExpandableRow && this.props.isExpandable && (
                      <Col md={1} className="d-flex justify-content-end">
                        <i class="fa fa-angle-down" aria-hidden="true" />
                      </Col>
                    )}
                  </Row>

                  {this.props.isExpandable &&
                    this.state.expandRowIndex.length !== 0 &&
                    this.state.expandRowIndex.includes(index) && (
                      <Row className={"expandedSecondRow display-center"}>
                        <div className="width-75">
                          <Row className={"amortizationHeader"}>
                            {this.state.auditTrailSecondRowColumns.map(
                              (column) => {
                                return (
                                  <Col md={4} className="text-left">
                                    {Strings(column)}
                                  </Col>
                                );
                              }
                            )}
                          </Row>
                          {row.secondRowData?.map((secondRow) => {
                            return (
                              <Row className={"firstRow"}>
                                {this.state.auditTrailSecondRowColumns.map(
                                  (column) => {
                                    let nestedColumns =
                                      secondRow[column] !== null &&
                                      typeof secondRow[column] === "object" &&
                                      Object.keys(secondRow[column]);

                                    return secondRow[column] !== null &&
                                      typeof secondRow[column] === "object" ? (
                                      <Col md={4} className="text-left">
                                        <Row>
                                          {nestedColumns.map((nestedColumn) => {
                                            return (
                                              <Row>
                                                {this.renderNestedColumns(
                                                  secondRow,
                                                  column,
                                                  nestedColumn
                                                )}
                                              </Row>
                                            );
                                          })}
                                        </Row>
                                      </Col>
                                    ) : (
                                      <Col md={4} className="text-left">
                                        {this.renderExpandableRowValues(
                                          row,
                                          secondRow,
                                          column
                                        )}
                                      </Col>
                                    );
                                  }
                                )}
                              </Row>
                            );
                          })}
                        </div>
                      </Row>
                    )}
                </>
              );
            })}
            <Pagination
              activePage={this.state.activePage}
              recordsPerPage={this.state.recordsPerPage}
              numberOfPages={this.props.numberOfPages}
              onPageChange={this.onPageChange}
              dropup={true}
            />
          </>
        ) : (
          <div className="noRecordsFound text-center">
            {Strings("noRecordsFound")}
          </div>
        )}
      </Row>
    );
  }
}

export default withRouter(AuditTrail);
